import * as yup from 'yup';
import { setLocale } from '../../../utils/yup-utils';

setLocale();

const validationRules = {
  username: yup.string().email().required(),
  password: yup.string().required(),
};

const validate = async (form) => {
  const schema = await yup.object().shape(validationRules);

  try {
    const data = await schema.validate(form, { abortEarly: false });
    return { isValid: true, data, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner) {
      err.inner.forEach((error) => { errors[error.path] = error.message; });
    }
    return { isValid: false, data: form, errors };
  }
};

export default validate;